<template>
    <div class="page">
        <div class="page-wide page-header">
            <div class="page-center">
                <TheHeader />
            </div>
        </div>
        <div class="page-wide page-content">
            <div class="page-center">
                <router-view />
            </div>
        </div>
        <div class="page-wide page-footer">
            <div class="page-center">
                <TheFooter />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Bus, Stops } from './common/bus';
import TheHeader from './components/common/TheHeader.vue';
import TheFooter from './components/common/TheFooter.vue';

export default {
    name: 'App',
    metaInfo: {
        meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, user-scalable=no' }],
    },
    components: { TheHeader, TheFooter },
    created() {
        Bus.$on(Stops.UNAUTHORIZED, () => this.$router.push({ name: 'Auth' }));
        this.getProfile();
    },
    methods: {
        ...mapActions('session', ['getProfile']),
    },
};
</script>

<style lang="scss">
html,
body {
    height: 100%;
    a.button,
    button {
        cursor: pointer;
        font-size: 1.1rem;
        background-color: $backgroundColor;
        padding: 0rem 0.5rem 0.1rem 0.5rem;
        transition: all 0.2s ease-in-out;
        border: 1px solid lightgrey;
        border-radius: 4px;
        margin-left: 0.2rem;
        &:hover {
            border: 1px solid $borderColorHover;
        }
    }
}

.page {
    font-family: 'Segoe UI', 'Sans Serif';
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    .page-wide {
        width: 100%;
    }
    .page-header {
        background-color: $backgroundColor;
        border-bottom: 1px solid $borderColor;
        height: $headerHeight;
        position: fixed;
        top: 0;
        z-index: 10;
    }
    .page-content {
        margin-top: $headerHeight;
        padding-top: 3px;
        background-color: $backgroundColorDefault;
        flex: 1;
    }
    .page-footer {
        background-color: $backgroundColor;
        border-top: 1px solid $borderColor;
        height: $footerHeight;
        display: flex;
    }
    .page-center {
        max-width: $maxContentWidth;
        text-align: center;
        margin: auto;
        flex: 1;
    }
}
</style>
